import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import { translate } from '@haldor/ui';
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import Moment from "moment";
import { getSchoolDetails } from "actions/schools";
import { setActiveSchool } from 'actions/user';
import { getActiveSchool } from 'helpers/localstorage';
import SectionTitle from 'components/Presentation/SectionTitle';
import { setPageTitle } from "actions/header";
import User from '_class/User';
import SchoolAdministration from './Partial/School';
import SubjectsAdministration from './Partial/Subjects';
import ExportAssessmentForSchool from './Partial/ExportAssessmentForSchool';
import UsersWithoutMentorGroups from './Partial/UsersWithoutMentorGroups';
import SMSAdmin from './Partial/SMS';
import { TooltipMenu, Tabs, Tab, getActiveLanguage } from '@haldor/ui';

var Admin = /*#__PURE__*/function (_Component) {
  _inherits(Admin, _Component);

  var _super = _createSuper(Admin);

  function Admin(props) {
    var _this;

    _classCallCheck(this, Admin);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var schools = [];

      _this.props.currentUser.schools.forEach(function (school) {
        if (_this.userSchoolAdmin(school.id)) {
          schools.push({
            title: school.title,
            id: school.id,
            type: school.type,
            typeLocalizes: _this.props.translate(school.type),
            typeOfSchools: [{
              id: 1,
              type: "PRESCHOOL"
            }, {
              id: 2,
              type: "COMPULSORY_SCHOOL"
            }, {
              id: 3,
              type: "UPPER_SECONDARY_EDUCATION"
            }, {
              id: 4,
              type: "ADULT_EDUCATION"
            }]
          });
        }
      });

      var schoolId = getActiveSchool(_this.props.currentUser.id);

      _this.props.getSchoolDetails(schoolId).then(function () {
        var school = _this.props.school;

        _this.setState({
          loading: false,
          schools: schools,
          school: school
        });
      });

      _this.props.setPageTitle(_this.props.translate('administration'));
    });

    _defineProperty(_assertThisInitialized(_this), "userSchoolAdmin", function (schoolId) {
      if (_this.props.currentUser.roles != null && _this.props.currentUser.roles.length > 0) {
        var schoolAdministrator = _this.props.currentUser.roles.find(function (role) {
          return role.roleId.toUpperCase() == "SCHOOL_ADMINISTRATOR" && role.referenceId == schoolId || role.roleId.toUpperCase() == "SYSADMIN";
        });

        if (schoolAdministrator != null) {
          return true;
        }
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "renderActiveSchoolAction", function (school) {
      return /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        key: 'school-id-' + school.id,
        onClick: function onClick() {
          return _this.switchSchool(school.id, _this.props.currentUser.id);
        }
      }, school.title);
    });

    _defineProperty(_assertThisInitialized(_this), "switchSchool", function (school, userId) {
      localStorage.setItem("hal.school" + userId, school);

      _this.props.setActiveSchool(school);

      _this.props.history.push("/administration");
    });

    Moment.locale(getActiveLanguage());
    _this.state = {
      school: [],
      schools: []
    };
    return _this;
  }

  _createClass(Admin, [{
    key: "render",
    value: function render() {
      var user = new User(this.props.currentUser);

      if (!user.isAdministrator()) {
        this.props.history.push('/');
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "general-administration"
      }, /*#__PURE__*/React.createElement(SectionTitle, null, /*#__PURE__*/React.createElement(TooltipMenu, {
        trigger: this.state.school.title,
        id: 'school-menu'
      }, this.state.schools.map(this.renderActiveSchoolAction))), /*#__PURE__*/React.createElement(Tabs, null, /*#__PURE__*/React.createElement(Tab, {
        title: this.props.translate('school'),
        route: "school"
      }, /*#__PURE__*/React.createElement(SchoolAdministration, null)), /*#__PURE__*/React.createElement(Tab, {
        title: this.props.translate('subjects'),
        route: "subjects"
      }, /*#__PURE__*/React.createElement(SubjectsAdministration, null)), /*#__PURE__*/React.createElement(Tab, {
        title: this.props.translate('Students without mentor groups'),
        route: "withoutMentorGroups"
      }, /*#__PURE__*/React.createElement(UsersWithoutMentorGroups, null)), /*#__PURE__*/React.createElement(Tab, {
        title: this.props.translate('Sms'),
        route: "sms"
      }, /*#__PURE__*/React.createElement(SMSAdmin, null))));
    }
  }]);

  return Admin;
}(Component);

function mapStateToProps(state, ownProps) {
  return {
    languages: state.Languages.languages,
    translate: translate(state.Languages.translations),
    services: state.Services.availableServices,
    currentUser: state.user.currentUser,
    school: state.School.active
  };
}

export default withRouter(connect(mapStateToProps, {
  setPageTitle: setPageTitle,
  setActiveSchool: setActiveSchool,
  getSchoolDetails: getSchoolDetails
})(Admin));